module.exports = __webpack_public_path__ + "img/card.521b10d1.png";